import { Component, OnInit } from '@angular/core';
import { Contract, Data, IonicColorEnum, ProductMovement } from '@mlc/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TransactionTypeEnum } from 'src/app/core/models/enums/transactionTypeEnum';
import { ActivityFeedService } from 'src/app/core/services/activity-feed/activity-feed.service';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';

@UntilDestroy()
@Component({
    selector: 'app-activity-feed',
    templateUrl: './activity-feed.component.html',
    styleUrls: ['./activity-feed.component.scss'],
    standalone: false
})
export class ActivityFeedComponent implements OnInit {

  public busy: boolean = true;
  public activities: (Data<ProductMovement> & { transactionType: TransactionTypeEnum; isPositive: boolean })[] = [];
  protected readonly IonicColorEnum = IonicColorEnum;

  constructor(private activityFeedService: ActivityFeedService, private contractService: ContractService) {}

  ngOnInit(): void {
    this.contractService.get()
    .pipe(untilDestroyed(this))
    .subscribe((contract: Data<Contract> | undefined) => {
      if (!contract) {
        this.busy = false;
        return;
      }
      this.activities = this.activityFeedService.mergeWithdrawalsDeposits(
        { movements: contract.attributes.withdrawals.data, type: TransactionTypeEnum.WITHDRAWAL },
        { movements: contract.attributes.deposits.data, type: TransactionTypeEnum.DEPOSIT }
      );
      this.busy = false;
    })
  }
}
